module.exports = __webpack_public_path__ + "img/tail-spin.a75a5f09.svg";